import React from "react";

const Process = ({ label }) => {
  return (
    <div className="rounded-full bg-gradient-to-r from-[#E476B4] to-[#E47056] p-0.5">
      <div className="flex flex-col justify-between h-full bg-black rounded-full px-4 py-2">
        <p className="text-sm text-transparent bg-clip-text bg-gradient-skill">
          {label}
        </p>
      </div>
    </div>
  );
};

export default Process;
